import {
  DuctedSwapLocks,
  DuctedSwapLocksBySystemId,
  DuctedSwapLockTarget
} from './ducted-component-swap-types';

export const DEFAULT_DUCTED_SWAP_LOCKS: DuctedSwapLocks = {
  outdoor: true,
  indoor: true,
  blower: true
};

export const ductedSwapLocksFor = (
  locksBySystemId: DuctedSwapLocksBySystemId,
  systemId: string
): DuctedSwapLocks => locksBySystemId[systemId] ?? DEFAULT_DUCTED_SWAP_LOCKS;

export const withDuctedSwapLocks = (
  locksBySystemId: DuctedSwapLocksBySystemId,
  systemId: string,
  locks: DuctedSwapLocks
): DuctedSwapLocksBySystemId => ({ ...locksBySystemId, [systemId]: locks });

export const withoutDuctedSwapLocks = (
  locksBySystemId: DuctedSwapLocksBySystemId,
  systemId: string
): DuctedSwapLocksBySystemId => {
  if (!(systemId in locksBySystemId)) return locksBySystemId;
  const { [systemId]: removed, ...rest } = locksBySystemId;
  return rest;
};

export const inheritDuctedSwapLocks = (
  locksBySystemId: DuctedSwapLocksBySystemId,
  target: DuctedSwapLockTarget,
  systemId: string
): DuctedSwapLocksBySystemId => {
  if (target.kind !== 'swap') return locksBySystemId;
  const inherited = locksBySystemId[target.replaceSystemId];
  if (!inherited) return locksBySystemId;
  return withDuctedSwapLocks(
    withoutDuctedSwapLocks(locksBySystemId, target.replaceSystemId),
    systemId,
    inherited
  );
};
